import { type FC } from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  getStreamSignalProblem,
  type Stream,
} from "@/partner/entities/streams";
import { interpolationFormat } from "@/partner/shared/lib";

interface StreamSignalAlertProps {
  stream: Stream;
}

/**
 * Плашка над вкладками диалога эфира, когда эфир идёт, а видео нет
 * (спека 2026-10-24-stream-monitoring-ux, часть 1, «Что видит партнёр»):
 * когда пропало и что проверить на площадке. Про плановый перерыв сказано
 * в тексте, чтобы пауза между боями не пугала.
 */
export const StreamSignalAlert: FC<StreamSignalAlertProps> = ({ stream }) => {
  const { t, i18n } = useTranslation();
  const problem = getStreamSignalProblem(stream);
  if (!problem || !stream.signal) return null;
  const time = interpolationFormat(stream.signal.since, "time", i18n.language);

  return (
    <Alert severity="error" variant="filled" sx={{ mx: 1, mt: 1 }}>
      {problem === "NO_VIDEO" ? (
        <>
          <AlertTitle>
            {t("streams.signal.bannerNoVideoTitle", { time })}
          </AlertTitle>
          {t("streams.signal.bannerNoVideo")}
        </>
      ) : (
        <>
          <AlertTitle>
            {t("streams.signal.bannerDisconnectedTitle", { time })}
          </AlertTitle>
          {t("streams.signal.bannerDisconnected")}
        </>
      )}
    </Alert>
  );
};
